<template>
    <section class="panel panel--content panel--grid-content panel--grid-filter panel--spaced" :class="background">
        <div v-if="title || description" class="panel__title" :class="{ 'text--center': panel_options.center_align_title }" style="padding: 3rem 0 0 0;max-width: calc(1340px + 4rem);margin-bottom: 0;margin-left:auto;margin-right:auto;">
            <h2 v-if="title" style="width: 100%;">{{ title }}</h2>
            <div v-if="description" class="panel__description" style="width: 100%;">
                <p>{{ description }}</p>
            </div>
        </div>
        <div class="panel__body" :style="[ title ? { padding: '0' } : null ]">
            <aside class="content content--aside content--aside-filter content--aside-top content--aside-sticky filter filter--vertical filter--secondary" role="complementary" aria-label="Filters">
                <div class="alert alert--secondary">
                    <div id="secondary-filters" class="filter__secondary" :class="{ 'is-visible': filter_visibility }">
                        <div class="filter__wrapper">
                            <h3>Filter by</h3>
                            <div class="filter__categories filter__section">
                                <div v-if="filters.search" class="filter__input">
                                    <div class="filter__box">
                                        <input v-model="search" v-debounce:500ms="filter_cards" id="site-search" class="form-control" type="text" placeholder="Filter sites by keyword" aria-label="sites filter - search for a site by name and tab through the matching sites in the section below" autocomplete="off">
                                    </div>
                                </div>
                                <div v-if="filters.categories" class="filter__select">
                                    <select v-model="selected_category" class="custom-select form-control" aria-label="academic divisions">
                                        <option v-for="category in categories_array" :value="category" :key="category">
                                            {{ category }}
                                        </option>
                                    </select>
                                </div>
                                <div v-if="filters.tags" class="filter__select">
                                    <select v-model="selected_tag" class="custom-select form-control" aria-label="signature research themes">
                                        <option v-for="tag in tags_array" :value="tag" :key="tag">
                                            {{ tag }}
                                        </option>
                                    </select>
                                </div>
                                <button v-if="show_reset_button" class="text__link filter__reset" @click="reset_filters" >Reset filters</button>
                            </div>
                        </div>
                    </div>
                </div>
            </aside>
            <div class="filter-sort--right">
                <button @click="filter_visibility = !filter_visibility" type="button" id="filter__toggle" aria-controls="secondary-filters" aria-expanded="false" aria-hidden="true" class="button button--primary filter__toggle-button">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <title>equalizer</title>
                        <path d="M2.5 20c-0.276 0-0.5-0.224-0.5-0.5v-8c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v8c0 0.276-0.224 0.5-0.5 0.5z"></path>
                        <path d="M2.5 6c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v5c0 0.276-0.224 0.5-0.5 0.5z"></path>
                        <path d="M3.5 10h-2c-0.827 0-1.5-0.673-1.5-1.5s0.673-1.5 1.5-1.5h2c0.827 0 1.5 0.673 1.5 1.5s-0.673 1.5-1.5 1.5zM1.5 8c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2z"></path>
                        <path d="M9.5 20c-0.276 0-0.5-0.224-0.5-0.5v-4c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v4c0 0.276-0.224 0.5-0.5 0.5z"></path>
                        <path d="M9.5 10c-0.276 0-0.5-0.224-0.5-0.5v-9c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v9c0 0.276-0.224 0.5-0.5 0.5z"></path>
                        <path d="M10.5 14h-2c-0.827 0-1.5-0.673-1.5-1.5s0.673-1.5 1.5-1.5h2c0.827 0 1.5 0.673 1.5 1.5s-0.673 1.5-1.5 1.5zM8.5 12c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2z"></path>
                        <path d="M16.5 20c-0.276 0-0.5-0.224-0.5-0.5v-10c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v10c0 0.276-0.224 0.5-0.5 0.5z"></path>
                        <path d="M16.5 4c-0.276 0-0.5-0.224-0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v3c0 0.276-0.224 0.5-0.5 0.5z"></path>
                        <path d="M17.5 8h-2c-0.827 0-1.5-0.673-1.5-1.5s0.673-1.5 1.5-1.5h2c0.827 0 1.5 0.673 1.5 1.5s-0.673 1.5-1.5 1.5zM15.5 6c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2z"></path>
                    </svg>
                    <span>Filters</span>
                </button>
            </div>
            <div class="content content--main content--filter">
                <div class="content--card">
                    <ul v-if="filtered_cards.length > 0" class="content content--card-grid content--card-grid-two-mobile">
                        <template v-for="card in filtered_cards">
                            <card 
                                :key="card.id"
                                :image_url="card.thumbnail_image"
                                :title="card.title"
                                :short_title="card.short_title"
                                :url="card.url"
                                :text="card.text" 
                                :center_content="panel_options.center_align_card_content"
                                :hide_card_arrows="panel_options.hide_card_arrows"
                                :categories="card.categories"
                                :tags="card.tags"
                                :show_labels="card_labels" >
                            </card>
                        </template>
                    </ul>
                    <div v-if="filtered_cards.length == 0" class="alert alert--striped">
						We don't have any items matching those filters.
					</div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Card from './card.vue'
import mixins from '../mixins.js'

export default {
    components: {
        'card': Card
    },
    props: {
        panel_number: Number,
        title: String,
        description: String,
        background: String,
        card_labels: Array,
        filters: Array,
        labels: Array,
        presets: Array,
        panel_options: Array,
        cards: Array
    },
    mixins: [ mixins ],
    data() {
        return {
            filter_visibility: false,
            filtered_cards: [],
            categories_array: [],
            tags_array: [],
            all_labels: {
                categories: '',
                tags: ''
            },
            search: '',
            selected_category: '',
            selected_tag: '',
            search_padding: ''
        }
    },
    computed: {
        show_reset_button() {
            if(this.search.length > 0 || this.selected_category != this.all_labels.categories || this.selected_tag != this.all_labels.tags) {
                return true;
            }
            return false;
        }
    }, 
    watch: {
        selected_category() {
            this.filter_cards();
        },
        selected_tag() {
            this.filter_cards();
        }
    },
    methods: {
        add_all_filter_dropdown_labels() {
            // Now add in our generic All list item
            this.categories_array.splice(0, 0, this.all_labels.categories); 
            this.tags_array.splice(0, 0, this.all_labels.tags); 
        },
        create_filter_dropdown_values() {
            // Loop through all of the links
            for(var i = 0; i < this.filtered_cards.length; i++){
                // Loop through the tags, if any, for that link
                for(var j = 0; j < this.filtered_cards[i]['categories'].length; j++){
                    // Now check to see if it is already in the array, and if not add it
                    if(!this.categories_array.includes(this.filtered_cards[i]['categories'][j])){
                        this.categories_array.push(this.filtered_cards[i]['categories'][j]);
                    }
                }
                // Loop through the tags, if any, for that link
                for(var k = 0; k < this.filtered_cards[i]['tags'].length; k++){
                    // Now check to see if it is already in the array, and if not add it
                    if(!this.tags_array.includes(this.filtered_cards[i]['tags'][k])){
                        this.tags_array.push(this.filtered_cards[i]['tags'][k]);
                    }
                }
            }
            // Sort the objects
            this.categories_array.sort();
            this.tags_array.sort();
        },
        filter_cards() {            
            // Load all cards
            let cards = this.cards;
            let category = this.selected_category;
            let tag = this.selected_tag;

            // Filter by category
            function filterByCategory(item) {
                if(item.categories.includes(category)) {
                    return true
                } 
                return false;
            }

            if(this.selected_category !== this.all_labels.categories) {
                cards = cards.filter(filterByCategory);
            }

            // Filter by tag
            function filterByTag(item) {
                if(item.tags.includes(tag)) {
                    return true
                } 
                return false;
            }

            if(this.selected_tag !== this.all_labels.tags) {
                cards = cards.filter(filterByTag);
            }

            // Filter by search
            let search_term = this.search.toLowerCase();
            var results = [];              
            for(var i = 0; i < cards.length; i++) {
                for(var key in cards[i]) {
                    let value = cards[i][key];
                    // Need to loop through the keys rather than specifying them
                    if(typeof value === 'string') {
                        if(value.toLowerCase().indexOf(search_term) !== -1) {
                            if(!this.item_exists(results, cards[i])) {
                                results.push(cards[i])
                            }
                        } 
                    }
                }
            }
            cards = results;

            // Load final data into array
            this.filtered_cards = cards;
        },
        set_all_labels() {
            // Specify our All labels
            this.all_labels.categories = 'Choose a ' + this.labels.categories;
            this.all_labels.tags = 'Choose a ' + this.labels.tags;
        },
        set_selected_filters() {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
            // Set our selected category
            if(this.presets.category.length > 0) {
                this.selected_category = this.presets.category;
            } else {
                this.selected_category = this.all_labels.categories;
            }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
            // Set our selected tag
            if(this.presets.tag.length > 0) {
                this.selected_tag = this.presets.tag;
            } else {
                this.selected_tag = this.all_labels.tags;
            }
        },
        reset_filters() {
                        
            // If the search field is visible then reset
            if(this.filters.search == true) {
                this.search = '';
            }
            
            this.set_selected_filters();

            this.filter_cards();

        }
    },
    created() {
        this.filtered_cards = this.cards;

        this.create_filter_dropdown_values();

        this.set_all_labels();
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
        this.set_selected_filters();

        this.add_all_filter_dropdown_labels();

        this.filter_cards();
    }
}
</script>
